import axios from "axios";
import { ApiUrl } from "./apiConfig";

export const client = axios.create({
  baseURL: ApiUrl,
  headers: { "Content-Type": "application/json" },
});

// export const sallieClient = axios.create({
//   baseURL: SallieApiUrl,
//   headers: { "Content-Type": "application/json" },
// });
